"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Step_1 = __importDefault(require("semantic-ui-react/dist/commonjs/elements/Step"));
var genIcon_1 = __importDefault(require("../../../utils/genIcon"));
/**
 * Each child Item represents a step and should show a check mark if the step has been completed. Also, a title, description, and icon can all be added for more detail about each step.
 */
var Item = /** @class */ (function (_super) {
    __extends(Item, _super);
    function Item() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Item.prototype.render = function () {
        var _a = this.props, title = _a.title, description = _a.description, icon = _a.icon, iconRoot = _a.iconRoot, completed = _a.completed, active = _a.active, disabled = _a.disabled, onClick = _a.onClick, rest = __rest(_a, ["title", "description", "icon", "iconRoot", "completed", "active", "disabled", "onClick"]);
        return (React.createElement(Step_1.default, __assign({}, rest, { className: this.genClassName(), completed: completed, active: active, disabled: disabled, onClick: onClick, link: true }),
            icon && genIcon_1.default(icon, { root: iconRoot, size: 'large' }),
            React.createElement(Step_1.default.Content, null,
                React.createElement(Step_1.default.Title, null, title),
                React.createElement(Step_1.default.Description, null, description))));
    };
    Item.prototype.genClassName = function () {
        var classString = 'item';
        if (this.props.className) {
            classString += " " + this.props.className;
        }
        return classString;
    };
    Item.defaultProps = {
        iconRoot: 'common'
    };
    return Item;
}(React.Component));
exports.default = Item;
